import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AdminApp from "./AdminApp";
import { BASE, IS_ADMIN, TENANT_SLUG } from "./auth";
import "./index.css";

if (!IS_ADMIN && !TENANT_SLUG) {
  // Bare URL: send the user to their last tenant (or the default one).
  let last = "default";
  try { last = localStorage.getItem("dpdp_last_tenant") || last; } catch { /* ignore */ }
  window.location.replace(`/t/${last}/${window.location.search}`);
} else {
  try { if (TENANT_SLUG) localStorage.setItem("dpdp_last_tenant", TENANT_SLUG); } catch { /* ignore */ }
  createRoot(document.getElementById("root")).render(
    <BrowserRouter basename={BASE}>
      {IS_ADMIN ? <AdminApp /> : <App />}
    </BrowserRouter>
  );
}
